import '../../../resources/css/admin_style.css';
import styles from './component.module.css';
import {useNavigate} from "react-router-dom";
import { useState, useEffect, useContext } from 'react';
import {AuthContext} from "../../../utils/contextapi/AuthProvider";
import { IAM_PATH, IAM_SERVER_AUDIT_ADMIN } from '../../../utils/Config';
import axios from "../../../utils/api/axios";
// import { DialogEnum, showDialog } from '../../../utils/dialog/Dialog';
import TimeAgo from '../../../utils/date/timeUtils';
import { getCookie } from '../../../utils/cookies/cookies';
import { InnocodeButton, useDialog } from '@intsoft/innocode-core';

function LogListItem({ log }) {
  let detail = {
      os: '알 수 없음',
      browser: '알 수 없음',
      deviceType: '알 수 없음',
      osVersion: '알 수 없음'
  };

  try {
      if (log.detail) {
          detail = JSON.parse(log.detail);
      }
  } catch (e) {
      console.error("Failed to parse log detail JSON:", e);
  }

  const formattedDate = new Date(log.createdDate).toLocaleString();

  return (
    <div className={styles.logListItem}>
      <div className={styles.logListItemLeft}>
        <div className={styles.logListItemTitle}>
          <TimeAgo date={log.createdDate} />
          {/* {formattedDate} */}
        </div>
        <div className={styles.logListItemSubtitle}>
          {log.subTypeView}
        </div>
      </div>
      <div className={styles.logListItemRight}>
        <div className={styles.logListItemDetail}>
          OS: {detail.os} | 브라우저: {detail.browser}
        </div>
        <div className={styles.logListItemDetail}>
          위치: {detail.location} | 기기: {detail.deviceType}
        </div>
      </div>
    </div>
  );
}

function LoginLogPanel({ }) {
  const { showDialog } = useDialog();
  const [loginLogs, setLoginLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const movePage = useNavigate();
  const {saveToken, saveAuthenticated, saveTokenExpiresIn, saveRole } = useContext(AuthContext);
  
  useEffect(() => {
    const userId = getCookie("user_id");

    const url = IAM_SERVER_AUDIT_ADMIN + "/all";

    const conditions = [
        { field: "unifiedProfileId", operator: "EQUALS", value: userId },
        { field: "mainType", operator: "EQUALS", value: "OAAM0100" },
        { field: "subType", operator: "EQUALS", value: "OAAS0100" }
    ];

    // 최종 params 구성
    const params = {
        page: 0,
        size: 10,
        sortField: ["createdDate"],
        sortOrder: ["desc"],
        operator: "AND",
        conditions
    };

    axios.post(url, params)
        .then((res) => {
            const { data } = res.data.data;
            setLoginLogs(data); // 상태에 데이터 저장
        })
        .catch((e) => {
        });


  }, []);

  const handleLogoutAll = () => {
    showDialog({
      iconType: "warning",
      type: 'delete',
      title: "로그아웃",
      message: "모든 기기에서 로그아웃 하시겠습니까?",
      confirmText: "예",
      cancelText: "아니요",
      onConfirm: () => {
        setLoading(true);
        const userId = getCookie("user_id");
        const url = IAM_PATH + "/logout-all"; // 서버의 API 경로
        const data = { unifiedProfileId: userId };
        
        axios.post(url, data)
            .then((res) => {
                showDialog({
                  iconType: "check",
                  type: 'info',
                  title: "로그아웃",
                  message: "모든 기기에서 로그아웃 처리되었습니다.",
                  confirmText: "확인",
                });
                saveTokenExpiresIn(null);
                saveToken("");
                saveAuthenticated(false);
                saveRole("");
                sessionStorage.clear();
                movePage('/login');
                setLoading(false);
            })
            .catch((e) => {
                console.error("전체 로그아웃 중 오류가 발생했습니다.", e);
                showDialog({
                  iconType: "warning",
                  type: 'error',
                  title: "로그아웃",
                  message: "전체 로그아웃 중 오류가 발생했습니다.",
                  confirmText: "확인",
                });
                setLoading(false);
            });
    }});
  };

  return (
    <div className={styles.infoCard}>
      <div className={styles.infoTitleContainer}>
        <h2 className={styles.infoTitle}>최근 로그인 이력</h2>
        {/* <button 
          className={styles.logoutAllButton} 
          onClick={handleLogoutAll} 
          disabled={loading}>
          {loading ? '처리 중...' : '모든 기기에서 로그아웃'}
        </button> */}
        <InnocodeButton backgroundColor=' var(--status-negative, #f83a3a)' onClick={handleLogoutAll} disabled={loading}>{loading ? '처리 중...' : '모든 기기에서 로그아웃'}</InnocodeButton>
      </div>
      <h3 className={styles.infoSubTitle}>
        최근 10개의 로그인 이력
      </h3>
      <div className={styles.logListContainer}>
        {loginLogs.length > 0 ? (
          loginLogs.map(log => <LogListItem key={log.auditId} log={log} />)
        ) : (
          <p>로그인 이력이 없습니다.</p>
        )}
      </div>
    </div>
  );
}

export default LoginLogPanel;
